var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('pcHeaderNew'),_c('div',{staticClass:"content-block"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('pcFooterNew')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }